import EmbeddedVideo from "./EmbeddedVideo";
import './Results.css';

export default function Results() {
    return (
        <div id="results">
            <h2 className="col-md-12 section-heading text-center wow fadeInUp">Results</h2>
            <div className="results-content">
                <p>The importance of results is something I am acutely aware of. I take great pride in the achievements of my students, from moving up sets at school to getting the grades they need for University.</p>
                <p>For the past 5 years in a row (2022-26) at least one of my students has made it to Oxbridge. This year (2026), Josiah was successful in gaining a place at Cambridge to study Chemical Engineering after securing a grade A* in A-level Further Maths.</p>
                <p>Furthermore, in 2026 80% of my A-level students were awarded an A or A* in Maths with one student, Raphael, achieving 95% (284/300) in Further Maths.</p>
                <p>Students and parents often ask me what is required to secure a place at Oxford or Cambridge. In the attached video I interview one of my former pupils, Illya, a Cambridge maths graduate for some valuable tips so that others may follow in his footsteps.</p>
            </div>
            <EmbeddedVideo src={"https://www.youtube.com/embed/WSuWoX0tkU0"} />
        </div>
    );
};
